import { ifJustLoggedIn } from "@/pages/LayoutFeatures/Account/ifJustLoggedIn";
import { newContainer } from "@/utils";

async function installRemindSelectTemplateModal() {
  const container = newContainer();
  const { default: Vue } = await import("vue");
  const { default: RemindSelectTemplateModal } = await import(
    /* webpackChunkName: "RemindSelectTemplateModal" */ "./RemindSelectTemplateModal.vue"
  );
  new Vue({
    render: (h) => h(RemindSelectTemplateModal, {}),
  }).$mount(container);
}

export async function checkRemindSelectTemplate(): Promise<void> {
  ifJustLoggedIn(async () => {
    console.log("We just logged in");
    await installRemindSelectTemplateModal();
  });
}
